//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DirectToLenderNavigation",
  props: {
    page: {
      type: String,
      required: true
    }
  },
  computed: {
    pages() {
      const pages = {
        "credit-bureau": {
          label: this.$t("direct-to-lender.navigation.credit-bureau"),
          section: "credit-bureau",
          key: "credit-bureau"
        },
        participants: {
          label: this.$t("direct-to-lender.navigation.participants"),
          section: "participants",
          key: "participants"
        },
        "lender-submit": {
          label: this.$t("direct-to-lender.navigation.lender-submit"),
          key: "lender-submit"
        },
        "lender-response": {
          label: this.$t("direct-to-lender.navigation.lender-response"),
          key: "lender-response"
        },
        fees: {
          label: this.$t("direct-to-lender.navigation.fees"),
          key: "fees"
        },
        commissions: {
          label: this.$t("direct-to-lender.navigation.commissions"),
          key: "commissions"
        }
      };
      return pages;
    }
  },
  methods: {
    handlePageChange(key) {
      this.$emit("page-change", key);
    },
    handleSectionNavigation(page, section, subSection) {
      const element = `#${section}${subSection ? ` #${subSection}` : ""}`;
      if (page !== this.page) {
        this.handlePageChange(page);
        this.$nextTick(() => {
          setTimeout(() => this.navigateTo(element, 1000), 500);
        });
        return;
      }
      this.navigateTo(element);
    },
    navigateTo(element, duration = 500) {
      this.$nextTick(() => {
        this.$scrollTo(element, duration, {
          container: "#app-data-container",
          force: true,
          cancelable: true
        });
      });
    }
  }
});